import { SettingsIcon } from '@viapeople/components'
import { Outlet, useNavigate, useParams } from 'react-router-dom'
import { type Column, GenericTable } from '../../../../components/GenericTable'
import { trpc } from '../../../../utils/trpc'
import type { CycleReviewer, CycleReviewerSearchInput } from '../types'
import { CycleReviewersAddModal as CycleReviewersAddModalComponent } from './CycleReviewersAddModal'
import { CycleReviewersFileUploadModal as CycleReviewersFileUploadModalComponent } from './CycleReviewersFileUploadModal'

export const CycleReviewersFileUploadModal = () => {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()

	const onClose = () => {
		navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/list`)
	}

	return <CycleReviewersFileUploadModalComponent isOpen onClose={onClose} onUploadSuccess={onClose} />
}

export const CycleReviewersAddModal = () => {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()

	const onClose = () => {
		navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/list`)
	}

	return <CycleReviewersAddModalComponent isOpen onClose={onClose} />
}

export function CycleReviewersListTab() {
	const { organizationId, cycleId } = useParams<{ organizationId: string; cycleId: string }>()
	const navigate = useNavigate()

	const columns: Column<CycleReviewer>[] = [
		{
			field: 'firstName' as keyof CycleReviewer,
			label: 'Self Evaluator',
			render: (reviewer: CycleReviewer) => `${reviewer.participant.firstName} ${reviewer.participant.lastName}`,
		},
		{
			field: 'reviewers',
			label: 'Raters',
			sortable: false,
			colSpan: 4,
			render: (reviewer: CycleReviewer) =>
				reviewer.reviewers.map((reviewer) => `${reviewer.firstName} ${reviewer.lastName}`).join(', '),
		},
		{
			field: 'reviewers',
			sortable: false,
			label: 'Status',
			render: () => 'Awaiting Launch',
		},
	]

	return (
		<div>
			<GenericTable<CycleReviewer, CycleReviewerSearchInput>
				queryOptionsGenerator={(options) => ({
					...trpc.admin.cycles.reviewers.search.queryOptions({
						...options,
						cycleId: cycleId || '',
					}),
					enabled: !!cycleId,
				})}
				onRowClick={(row) => {
					navigate(`/organizations/${organizationId}/cycles/${cycleId}/reviewers/list/${row.participantExternalId}`)
				}}
				isInternal
				columns={columns}
				showPagination
				emptyState={{
					title: 'Configuration Incomplete',
					description: 'Configuration is required in order to view the rater list or upload a file',
					icon: SettingsIcon,
				}}
			/>

			<Outlet />
		</div>
	)
}
